// extracted by mini-css-extract-plugin
module.exports = {"timeStamp":"timestamp_timeStamp__oD1aI"};